$(document).ready(() => {

    let pub = getCookie("pub");
    if (pub == 0) {
        $('.img-promo--wrapper').css('transform', 'translateX(0%)');
        
    }
    else{
        $('.img-promo--wrapper').css('display', 'none');
        $('.promo__title').css('display','none');
    }

    $('#close-pub').on('click', () => {

        $('.img-promo--wrapper').css('transform', 'translateX(100%)');
        setCookie('pub', 'stop', 1);
    });

});

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}